import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { bool, shape } from 'prop-types';
import { useSelector } from 'react-redux';

import { formatCurrency } from '@ajaibid/utils';
import { IconSvg } from '@ajaibid/components';
import { MENU } from '@screens/Rdn/constant';
import ICON_INFO from 'Icon/MenuProfile/svg/IconInfo';
import ICON_WALLET from 'Icon/MenuProfile/svg/IconClock';
import ICON_TOPUP from 'Icon/MenuProfile/svg/IconTopUp';
import ICON_HISTORY from 'Icon/MenuProfile/svg/IconHistory';
import ICON_WITHDRAW from 'Icon/MenuProfile/svg/IconWithdrawl';
import ICON_SETTLEMENTS from 'Icon/MenuProfile/svg/IconTransaction';
import ICON_SACK_OF_COINS from 'Icon/icon_sack_of_coins.png';

import {
  styBalanceAction,
  styBalanceItem,
  styBalanceTitle,
  styPaymentAction,
  styPaymentAmount,
  styPaymentInfo,
  styPaymentInfoWrapper,
  styPaymentSection,
  styPaymentTitle,
} from './style';
import PopupOngoingRdn from './PopupOngoingRdn';
import PopupInfoPayment from './PopupInfoPayment';

const PaymentInfo = ({ isPremium, isPremiumTrial, profileRdn }) => {
  const navigate = useNavigate();
  const configData = useSelector((state) => state.config.configData);
  const isShowRdnNegative = configData?.show_rdn_negative === '1';
  const cashLog = profileRdn?.cash_log || [];
  const [isShowPopup, setIsShowPopup] = useState(false);
  const [infoPaymentData, setInfoPaymentData] = useState({
    isOpen: false,
    img: null,
    title: '',
    content: '',
  });

  const hideModal = useCallback(() => {
    setInfoPaymentData({ ...infoPaymentData, isOpen: false });
  });

  const balanceItems = [
    {
      name: 'Deposit',
      icon: <ICON_TOPUP />,
      onClick: () => {
        navigate('/rdn', { state: { tabMenu: MENU.TOPUP } });
      },
    },
    // {
    //   name: 'Tarik',
    //   icon: <ICON_WITHDRAW />,
    //   onClick: () => {
    //     navigate('/rdn', { state: { tabMenu: MENU.WITHDRAW } });
    //   },
    // },
    {
      name: 'Riwayat',
      icon: <ICON_HISTORY />,
      onClick: () => {
        navigate('/rdn', { state: { tabMenu: MENU.HISTORY } });
      },
    },
    {
      name: 'Settlement',
      icon: <ICON_SETTLEMENTS />,
      onClick: () => {
        navigate('/rdn', { state: { tabMenu: MENU.SETTLEMENT } });
      },
    },
  ];

  return (
    <div className={styPaymentInfoWrapper({ isPremium, isPremiumTrial })}>
      <div style={{ display: 'flex' }}>
        <span className={styPaymentTitle}>Saldo Bisa Ditarik</span>
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setInfoPaymentData({
              isOpen: true,
              img: ICON_SACK_OF_COINS,
              title: 'Saldo RDN',
              content:
                'Merupakan dana yang tersimpan dalam Rekening Dana Nasabah milikmu. Sesuai ketentuan bursa (aturan T+2), transaksi jual/beli saham selesai sepenuhnya dalam waktu dua hari. Penyesuaian angka pada saldo RDN akan mengikuti ketentuan tersebut.',
            });
          }}
        >
          <ICON_INFO />
        </div>
      </div>
      <div>
        <span className={styPaymentAmount}>{formatCurrency(profileRdn.cash_available, 'IDR')}</span>
      </div>
      <div className={styPaymentInfo} onClick={() => setIsShowPopup(true)}>
        <div className={styPaymentSection}>
          <ICON_WALLET />
          <span style={{ marginLeft: 4 }}>Saldo Diproses</span>
        </div>
        <div className={styPaymentSection}>
          <span> {formatCurrency(profileRdn.total_pending_positive_settlement, 'IDR')} </span>
          <IconSvg.Chevron.Right size={20} color="#3A83F9" />
        </div>
      </div>
      <div className={styPaymentAction}>
        {balanceItems.map((item) => (
          <div className={styBalanceItem} onClick={() => item.onClick()}>
            <div className={styBalanceAction}>{item.icon}</div>
            <span className={styBalanceTitle}>{item.name}</span>
          </div>
        ))}
      </div>
      <PopupOngoingRdn
        isShowPopup={isShowPopup}
        setIsShowPopup={setIsShowPopup}
        isShowRdnNegative={isShowRdnNegative}
        balance={profileRdn?.cash_available}
        cashLog={[...cashLog]?.reverse()}
        cashRaw={profileRdn?.cash_available_raw}
        onGoingAmount={profileRdn?.total_pending_positive_settlement}
      />
      <PopupInfoPayment infoPaymentData={infoPaymentData} hideModal={hideModal} />
    </div>
  );
};

PaymentInfo.propTypes = {
  isPremium: bool,
  isPremiumTrial: bool,
  profileRdn: shape({}),
};

PaymentInfo.defaultProps = {
  isPremium: false,
  isPremiumTrial: false,
  profileRdn: {},
};

export default PaymentInfo;
